import { BlogAPI } from "./Types/BlogAPI";
import { FormAPI } from "./Types/FormAPI";
import { FranchiseAPI } from "./Types/FranchiseAPI";
import { ListingsAPI } from "./Types/ListingsAPI";
import { OfficeAPI } from "./Types/OfficeAPI";
import { SlugAPI } from "./Types/SlugAPI";
import { TestimonialAPI } from "./Types/TestimonialAPI";
import { WebsiteAPI } from "./Types/WebsiteAPI";
import { ProfileAPI } from "./Types/ProfileAPI";
import { CRMAPI } from "./Types/CRMAPI";
import { CalculatorAPI } from "./Types/CalculatorAPI";
import { PaymentAPI } from "./Types/PaymentAPI";

class API {
    static Blogs: BlogAPI = new BlogAPI();
    static Forms: FormAPI = new FormAPI();
    static Franchises: FranchiseAPI = new FranchiseAPI();
    static Listings: ListingsAPI = new ListingsAPI();
    static Offices: OfficeAPI = new OfficeAPI();
    static Slugs: SlugAPI = new SlugAPI();
    static Testimonials: TestimonialAPI = new TestimonialAPI();
    static Website: WebsiteAPI = new WebsiteAPI();
    static Profiles: ProfileAPI = new ProfileAPI();
    static CRM: CRMAPI = new CRMAPI();
    static Calculators: CalculatorAPI = new CalculatorAPI();
    static Payment: PaymentAPI = new PaymentAPI();
}

export { API }
